// Pure helpers that derive the deduped counterparty-system lists from a config
// payload (the `/api/v1/config` response: { identity, produces, consumes }).
//
// IMPORTANT: agent-principal relations carry their data in `to_agents` /
// `from_agents` and leave the legacy `to` / `from` fields as `null`. Every
// dereference here must therefore tolerate a null target list.

const dedupeById = systems =>
	systems.filter((currentSystem, index, all) =>
		all.findIndex(system => system.id === currentSystem.id) === index)

// Flatten `relations[].<key>` into a single system list. `relation[key]` may be
// null (agent-principal relations) or an array that itself contains null
// entries, so drop every falsy value before anything dereferences `.id`.
const flattenTargets = (relations, key) =>
	(relations ?? [])
		.map(relation => relation?.[key])
		.flat(1)
		.filter(Boolean)

export const getProvideSystems = value =>
	dedupeById(flattenTargets(value.produces, 'to'))

export const getConsumeSystems = value =>
	dedupeById(flattenTargets(value.consumes, 'from'))

export const getAllSystems = value => {
	const allSystems = [
		...flattenTargets(value.produces, 'to'),
		...flattenTargets(value.consumes, 'from'),
	]
	const myPitstopSystem = {
		id: value.identity.id,
		name: 'My Pitstop',
		systems: [{ id: value.identity.id }],
		system: { id: value.identity.id },
		on_behalf_of: [],
	}
	return [...dedupeById(allSystems), myPitstopSystem]
}

// Does any relation route on-behalf-of another participant? `relation[key]` can
// be null for agent-principal relations, so guard before `.some`.
export const hasOnBehalfOf = (relations, key) =>
	(relations ?? []).some(relation =>
		(relation?.[key] ?? []).some(
			entry => entry.on_behalf_of && entry.on_behalf_of.length > 0))
